import { useMutation } from "@tanstack/react-query";

import cmsClient from "src/services/cmsClient";

const createObservationAnswer = async (
	payload: Partial<AdminObservationAnswer>
) => {
	const url = "/observations/admin/answers/";
	const response = await cmsClient.post<AdminObservationAnswer>(url, payload);

	return response.data;
};

const useCreateObservationAnswer = () => {
	const mutation = useMutation(createObservationAnswer);

	return mutation;
};

export default useCreateObservationAnswer;
